<script setup lang="ts">
import { useNotifications } from "@/notifications/useNotifications";
import { Xmark } from "@iconoir/vue";
import { onMounted } from "vue";

const { notifications, acknowledgeNotification, syncPendingNotifications } =
  useNotifications();

onMounted(() => {
  syncPendingNotifications();
});
</script>

<template>
  <ul id="notifications">
    <li v-for="notification in notifications" :key="notification.id">
      <div>{{ notification.message }}</div>
      <button
        class="button button--tertiary"
        @click="acknowledgeNotification(notification.id)"
      >
        <span class="visually-hidden">Schließen</span><Xmark />
      </button>
    </li>
  </ul>
</template>

<style scoped>
#notifications li {
  color: var(--text-color-success);
  background-color: var(--bg-color-success);
  padding: var(--spacing-sm);
  border-color: var(--text-color-success);
  border-style: solid;
  border-radius: var(--border-radius-dialog);
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: var(--shadow);
}
</style>
